export interface ILayoutResourceStrings {
    name: string;
    company: string;
    from: string;
    phoneNumber: string;
}

export interface ILayoutResources {
    [key: string]: ILayoutResourceStrings;
}

const engb = "en-GB";
const etee = "et-EE";
const ruru = "ru-RU";

export const ActiveVisitationTableHeaderTranslations: ILayoutResources = {
    [engb]: {
        name: "Name",
        company: "Company",
        from: "From",
        phoneNumber: "Phone number"
    },
    [ruru]: {
        name: "Имя",
        company: "Компания",
        from: "От",
        phoneNumber: "Номер телефона"
    },
    [etee]: {
        name: "Nimi",
        company: "Ettevõte",
        from: "Alates",
        phoneNumber: "Tel. nr"
    }
};

export default ActiveVisitationTableHeaderTranslations;
